module.exports = __webpack_public_path__ + "img/home-analytics-2.508930f0.svg";